<div class="icon">
    <i class="fa fa-file-text">
    </i>
</div>
<div class="info">
    <span class="title">{{ reportFile.name }}</span>
    <span class="subtitle">{{'admin.strain.registry.details.measurements.reportCreatedBy' | translate}}
        {{reportFile.createdBy.firstName}} {{reportFile.createdBy.lastName}}, {{reportFile.createdAt}} </span>
    <div class="actions">
        <app-icon *ngIf="hasType(reportType.Pdf)"
                  [simple]="true"
                  type="info"
                  library="fontawesome"
                  variant="fa-file-pdf-o"
                  pTooltip="Download PDF"
                  (click)="doSelect(reportType.Pdf)">
        </app-icon>
        <app-icon *ngIf="hasType(reportType.Docx)"
                  [simple]="true"
                  type="info"
                  library="fontawesome"
                  variant="fa-file-text"
                  pTooltip="Download DocX"
                  (click)="doSelect(reportType.Docx)">
        </app-icon>
    </div>
</div>
<div class="remove" *ngIf="canDelete">
    <app-icon [simple]="true"
              type="danger"
              library="fontawesome"
              variant="fa-remove"
              (click)="doRemove()">
    </app-icon>
</div>
